const config = require("../env.json")

export const cargosSistema=[
    {
        'Id':1,
        'Nombre':'Administrativa'
    },
    {
        'Id':2,
        'Nombre':'Coordinadora'
    },
    {
        'Id':3,
        'Nombre':'Psicóloga'
    },
    {
        'Id':4,
        'Nombre':'Tallerista'
    },
    {
        'Id':5,
        'Nombre':'Terapeuta Ocupacional'
    }

];
import { validarSesion } from "./Auth";

export const editarUsuarioSistema=async(usuario,token)=>{

    const url=config.REACT_APP_WEBAPI_URL+`/usuarios`;
    const resp=await fetch(url,
        {
            method:"PATCH",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
                    
                
            },
            body:JSON.stringify(usuario)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;

};
export const reinicioContrasena=async(usuario,token)=>{

    const url=config.REACT_APP_WEBAPI_URL+`/usuarios/reset`;
    const resp=await fetch(url,
        {
            method:"PATCH",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
                    
                
            },
            body:JSON.stringify(usuario)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;

};
export const crearUsuarioSistema=async(usuario,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/usuarios`;
    const resp=await fetch(url,
        {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(usuario)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;

};
export const obtenerUsuariosSistemaPorFiltro=async(filtro,token)=>{
    
    const url=config.REACT_APP_WEBAPI_URL+`/usuarios`;
    const resp=await fetch(
        url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        });
    
    validarSesion(resp.status)

    const {data}=await resp.json();
    if(filtro!='' && filtro!=undefined){
        const dataFiltro=data.filter(item=>{
            if( item.Correo.toUpperCase().includes(filtro.toUpperCase()) ||
                item.NombreSocial.toUpperCase().includes(filtro.toUpperCase())
            )
            {
                return item;
        }});
        console.warn(dataFiltro);
        return dataFiltro;
    }
    console.warn(data);
    return data;
};

export const obtenerUsuarioSistema=async(usuario,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/usuarios/`+usuario;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    data.FechaNacimiento=data.FechaNacimiento.substring(0,10);
    return data;

};

